export default __webpack_public_path__ + "static/media/scientists-07.696fc22e.svg";